import { Foundation } from 'foundation-sites/js/foundation.core'
import $ from 'jquery'

import { rtl, GetYoDigits, transitionend } from 'foundation-sites/js/foundation.core.utils'
import { Box } from 'foundation-sites/js/foundation.util.box'
import { onImagesLoaded } from 'foundation-sites/js/foundation.util.imageLoader'
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard'
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'
import { Motion, Move } from 'foundation-sites/js/foundation.util.motion'
import { Nest } from 'foundation-sites/js/foundation.util.nest'
import { Timer } from 'foundation-sites/js/foundation.util.timer'
import { Touch } from 'foundation-sites/js/foundation.util.touch'
import { Triggers } from 'foundation-sites/js/foundation.util.triggers'

import { Accordion } from 'foundation-sites/js/foundation.accordion'
import { Dropdown } from 'foundation-sites/js/foundation.dropdown'
import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu'
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas'
import { Reveal } from 'foundation-sites/js/foundation.reveal'
import { Tabs } from 'foundation-sites/js/foundation.tabs'

Foundation.addToJquery($)

// Add Foundation Utils to Foundation global namespace for backwards compatibility.
Foundation.rtl = rtl
Foundation.GetYoDigits = GetYoDigits
Foundation.transitionend = transitionend
Foundation.Box = Box
Foundation.onImagesLoaded = onImagesLoaded
Foundation.Keyboard = Keyboard
Foundation.MediaQuery = MediaQuery
Foundation.Motion = Motion
Foundation.Move = Move
Foundation.Nest = Nest
Foundation.Timer = Timer

Touch.init($)
Triggers.init($, Foundation)

Foundation.plugin(Accordion, 'Accordion')
Foundation.plugin(Dropdown, 'Dropdown')
Foundation.plugin(DropdownMenu, 'DropdownMenu')
Foundation.plugin(OffCanvas, 'OffCanvas')
Foundation.plugin(Reveal, 'Reveal')
Foundation.plugin(Tabs, 'Tabs')

if (module.hot) {
  // Most Foundation plugins work fine before styles are loaded, but Accordion does not.
  $(window).on('load', () => {
    $(document).foundation()
  })
} else {
  $(document).foundation()
}
